export enum RENT_METHOD {
  LONG_TERM = 'long-term',
  SHORT_TERM = 'short-term'
}

export const getRentMethodOptions = (t: (key: string) => string) => [
  { label: t('form.rentMethod.longTerm'), value: RENT_METHOD.LONG_TERM },
  { label: t('form.rentMethod.shortTerm'), value: RENT_METHOD.SHORT_TERM }
];

export enum SEX {
  MALE = 'male',
  FEMALE = 'female'
}

export const getGenderOptions = (t: (key: string) => string) => [
  { label: t('common.customer.male'), value: SEX.MALE },
  { label: t('common.customer.female'), value: SEX.FEMALE }
];

export enum CUSTOMER_TYPE {
  PERSONAL = 'person',
  BUSINESS = 'company'
}

export enum PAYMENT_METHOD {
  CASH = 'cash',
  CREDIT = 'credit',
  BANK_TRANSFER = 'bank_transfer',
  OTA_DEBT = 'ota_debt',
  DEBT = 'debt',
  ONEPAY = 'onepay'
}

export enum PAYMENT_TYPE {
  INCOME = 'income',
  EXPENSE = 'expense'
}

export enum PAYMENT_STATUS {
  DRAFT = 'draft',
  POSTED = 'posted',
  CANCELLED = 'cancelled'
}

export enum PAYMENT_STATUS_ACC {
  STAYED = 'stayed',
  IN_HOUSE = 'in_house',
  DEPOSIT = 'deposit',
  INVOICED = 'invoiced'
}

export enum TOUR_TYPE {
  SINGLE = 'single_tour',
  PACKAGE = 'tour_package'
}

export enum BOOKING_STATUS {
  ALLOT = 'allot',
  CHECKOUT = 'checkout',
  CONFIRM = 'initial',
  CANCEL = 'cancel'
}

export enum GROUP_STATUS {
  INITIAL = 'initial',
  CONFIRMED = 'confirmed',
  CANCELLED = 'cancelled',
  COMPLETED = 'completed'
}

export enum TourStatus {
  CONFIRM = 'confirm',
  COMPLETE = 'complete',
  CANCEL = 'cancel'
}

export const TOUR_STATUS_OPTIONS = (t: (key: string) => string) => [
  {
    value: TourStatus.CONFIRM,
    label: t('tour.tourStatus.confirm')
  },
  {
    value: TourStatus.COMPLETE,
    label: t('tour.tourStatus.complete')
  },
  {
    value: TourStatus.CANCEL,
    label: t('tour.tourStatus.cancel')
  }
];

export const TOUR_STATUS_NAMES: { [key in TourStatus]: string } = {
  [TourStatus.CONFIRM]: 'RS',
  [TourStatus.COMPLETE]: 'C/O',
  [TourStatus.CANCEL]: 'CL'
};

export const GROUP_STATUS_NAMES: { [key in BOOKING_STATUS]: string } = {
  [BOOKING_STATUS.CONFIRM]: 'RS',
  [BOOKING_STATUS.ALLOT]: 'IH',
  [BOOKING_STATUS.CANCEL]: 'CL',
  [BOOKING_STATUS.CHECKOUT]: 'C/O'
};

export const LIST_GROUP_STATUS_NAMES: { [key in GROUP_STATUS]: string } = {
  [GROUP_STATUS.INITIAL]: 'RS',
  [GROUP_STATUS.CONFIRMED]: 'RS',
  [GROUP_STATUS.CANCELLED]: 'CL',
  [GROUP_STATUS.COMPLETED]: 'C/O'
};

export const PAYMENT_STATUS_ACC_NAMES: { [key in PAYMENT_STATUS_ACC]: string } = {
  [PAYMENT_STATUS_ACC.STAYED]: 'Stayed',
  [PAYMENT_STATUS_ACC.IN_HOUSE]: 'In House',
  [PAYMENT_STATUS_ACC.DEPOSIT]: 'Deposit',
  [PAYMENT_STATUS_ACC.INVOICED]: 'Invoiced'
};

export const BOOKING_STATUS_OPTIONS = (t: (key: string) => string) => [
  { label: t('bookingPage.bookingList.bookingStatus.all'), value: '' },
  { label: t('bookingPage.bookingList.bookingStatus.confirm'), value: BOOKING_STATUS.CONFIRM },
  { label: t('bookingPage.bookingList.bookingStatus.allot'), value: BOOKING_STATUS.ALLOT },
  { label: t('bookingPage.bookingList.bookingStatus.cancel'), value: BOOKING_STATUS.CANCEL },
  { label: t('bookingPage.bookingList.bookingStatus.checkOut'), value: BOOKING_STATUS.CHECKOUT }
];

export const TOUR_TYPE_OPTIONS = (t: (key: string) => string) => [
  { label: t('bookingPage.bookingList.bookingStatus.all'), value: '' },
  { label: t('tour.singleTour'), value: TOUR_TYPE.SINGLE },
  { label: t('tour.tourPackage'), value: TOUR_TYPE.PACKAGE }
];

export const getTitleStatusOption = (t: (key: string) => string): Record<string, string> => ({
  [BOOKING_STATUS.CONFIRM]: t('form.bookingStatus.confirm'),
  [BOOKING_STATUS.ALLOT]: t('form.bookingStatus.allot'),
  [BOOKING_STATUS.CANCEL]: t('form.bookingStatus.cancel'),
  [BOOKING_STATUS.CHECKOUT]: t('form.bookingStatus.checkOut')
});

export enum CURRENCY {
  VND = 'vnd'
}

export const CURRENCY_OPTIONS = [{ label: 'VND', value: CURRENCY.VND }];

export enum PAYMENT_FOR {
  ROOM = 'room',
  SERVICE = 'service'
}
export const getPaymentForOptions = (t: (key: string) => string) => [
  { label: t('billPDFPage.roomCharge'), value: PAYMENT_FOR.ROOM },
  { label: t('billPDFPage.serviceCharge'), value: PAYMENT_FOR.SERVICE }
];

export const getPaymentForNames = (t: (key: string) => string): Record<string, string> => ({
  [PAYMENT_FOR.ROOM]: t('billPDFPage.roomCharge'),
  [PAYMENT_FOR.SERVICE]: t('billPDFPage.serviceCharge')
});

export enum ROOM_STATUS {
  S = 'S',
  FS = 'FS',
  ARR = 'ARR',
  DEP = 'DEP',
  LOCKED = 'LOCKED'
}

export const ROOM_STATUS_NAMES: any = {
  [ROOM_STATUS.S]: 'S',
  [ROOM_STATUS.FS]: 'FS',
  [ROOM_STATUS.ARR]: 'ARR',
  [ROOM_STATUS.DEP]: 'DEP',
  [ROOM_STATUS.LOCKED]: 'OOO'
};

export const ROOM_STATUS_OPTIONS = [
  { label: 'S', value: ROOM_STATUS.S },
  { label: 'FS', value: ROOM_STATUS.FS },
  { label: 'ARR', value: ROOM_STATUS.ARR },
  { label: 'DEP', value: ROOM_STATUS.DEP },
  { label: 'LOCKED', value: ROOM_STATUS.LOCKED }
];

export const TYPE_OF_QUARTERS = ['1', '2', '3', '4'];

export enum STATUS_STAYING_GUEST {
  ALLOT = 'allot',
  ALLOT_CHECKOUT = 'allot_checkout'
}

export const useStatusOptions = (t: (key: string) => string) => {
  return [
    {
      label: t('common.statuses.staying'),
      value: STATUS_STAYING_GUEST.ALLOT
    },
    {
      label: t('common.statuses.stayingAndCheckedOut'),
      value: STATUS_STAYING_GUEST.ALLOT_CHECKOUT
    }
  ];
};

export enum COUNTRY_STAYING_GUEST {
  VIETNAM = 'vietnam',
  GLOBAL = 'global',
  NON_DETERMINED = 'non_determined'
}

export const useCountryOptions = (t: (key: string) => string) => {
  return [
    { label: t('common.statuses.all'), value: '' },
    {
      label: t('stayingGuest.country.vietnam'),
      value: COUNTRY_STAYING_GUEST.VIETNAM
    },
    {
      label: t('stayingGuest.country.global'),
      value: COUNTRY_STAYING_GUEST.GLOBAL
    },
    {
      label: t('stayingGuest.country.non_determined'),
      value: COUNTRY_STAYING_GUEST.NON_DETERMINED
    }
  ];
};

export const getNationalityStatisticsOption = (
  t: (key: string) => string
): { [key: string]: string } => ({
  '': t('common.statuses.all')
});

export const getStatusNationalityStatisticsOptions = (
  t: (key: string) => string
): { [key: string]: string } => ({
  [STATUS_STAYING_GUEST.ALLOT_CHECKOUT]: t('common.statuses.stayingAndCheckedOut')
});

export enum EXPENSE_TYPE {
  EXPENSE_FROM_ROOM = 'room',
  UTILITIES_SERVICES = 'util_service',
  ELECTRICITY = 'electricity',
  WATER = 'water',
  INTERNET = 'internet',
  TELEVISION = 'television',
  PHONE = 'phone',
  MAINTENANCE = 'maintainance',
  ALLOWANCE = 'allowance',
  SALARY = 'salary',
  BONUS = 'bonus',
  SURCHARGE = 'surcharge',
  TAX = 'tax',
  COMMISSION = 'commission',
  ADVERTISE = 'advertise',
  PURCHASING = 'purchasing',
  SUPPLIER = 'supplier',
  FURNITURE = 'furniture_procurement',
  REVENUE = 'revenue_submission',
  OTHER = 'other'
}

export const getExpenseTypeOptions = (t: (key: string) => string) => [
  { label: t('form.expenseType.room'), value: EXPENSE_TYPE.EXPENSE_FROM_ROOM },
  { label: t('form.expenseType.utilService'), value: EXPENSE_TYPE.UTILITIES_SERVICES },
  { label: t('form.expenseType.electricity'), value: EXPENSE_TYPE.ELECTRICITY },
  { label: t('form.expenseType.water'), value: EXPENSE_TYPE.WATER },
  { label: t('form.expenseType.internet'), value: EXPENSE_TYPE.INTERNET },
  { label: t('form.expenseType.television'), value: EXPENSE_TYPE.TELEVISION },
  { label: t('form.expenseType.phone'), value: EXPENSE_TYPE.PHONE },
  { label: t('form.expenseType.maintenance'), value: EXPENSE_TYPE.MAINTENANCE },
  { label: t('form.expenseType.allowance'), value: EXPENSE_TYPE.ALLOWANCE },
  { label: t('form.expenseType.salary'), value: EXPENSE_TYPE.SALARY },
  { label: t('form.expenseType.surcharge'), value: EXPENSE_TYPE.SURCHARGE },
  { label: t('form.expenseType.tax'), value: EXPENSE_TYPE.TAX },
  { label: t('form.expenseType.commission'), value: EXPENSE_TYPE.COMMISSION },
  { label: t('form.expenseType.advertise'), value: EXPENSE_TYPE.ADVERTISE },
  { label: t('form.expenseType.purchasing'), value: EXPENSE_TYPE.PURCHASING },
  { label: t('form.expenseType.supplier'), value: EXPENSE_TYPE.SUPPLIER },
  { label: t('form.expenseType.furniture'), value: EXPENSE_TYPE.FURNITURE },
  { label: t('form.expenseType.revenue'), value: EXPENSE_TYPE.REVENUE },
  { label: t('form.expenseType.other'), value: EXPENSE_TYPE.OTHER }
];

export const usePaymentStateOptions = (t: (key: string) => string) => {
  return [
    {
      label: t('common.statuses.all'),
      value: ''
    },
    {
      label: t('paymentState.draft'),
      value: PAYMENT_STATUS.DRAFT
    },
    {
      label: t('paymentState.posted'),
      value: PAYMENT_STATUS.POSTED
    },
    {
      label: t('paymentState.cancelled'),
      value: PAYMENT_STATUS.CANCELLED
    }
  ];
};

export const getTransactionTypeOptions = (t: (key: string) => string) => [
  {
    label: t('common.statuses.all'),
    value: ''
  },
  {
    label: t('paymentState.posted'),
    value: PAYMENT_STATUS.POSTED
  },
  {
    label: t('paymentState.cancelled'),
    value: PAYMENT_STATUS.CANCELLED
  }
];

export const useShiftHandoverFormFields = (t: (key: string) => string) => [
  { label: t('managePage.shiftHandoverListPage.openingAmount'), name: 'openingAmount' },
  { label: t('managePage.shiftHandoverListPage.incomeAmount'), name: 'incomeAmount' },
  { label: t('managePage.shiftHandoverListPage.expenseAmount'), name: 'expenseAmount' },
  { label: t('managePage.shiftHandoverListPage.currentAmount'), name: 'currentAmount' },
  { label: t('managePage.shiftHandoverListPage.difference_amount'), name: 'difference' },
  { label: t('managePage.shiftHandoverListPage.actualAmount'), name: 'actualAmount' }
];

export enum VIP_LEVEL {
  NORMAL = 'normal',
  HIGH_PRIORITY = 'high_priority',
  TOP_TIER = 'top_tier'
}

export const getVipLevelMap = (t: (key: string) => string): Record<string, string> => ({
  [VIP_LEVEL.NORMAL]: t('form.vipLevel.normal'),
  [VIP_LEVEL.HIGH_PRIORITY]: t('form.vipLevel.highPriority'),
  [VIP_LEVEL.TOP_TIER]: t('form.vipLevel.topTier')
});

export const getVipLevelOptions = (t: (key: string) => string) => [
  {
    label: t('form.vipLevel.normal'),
    value: VIP_LEVEL.NORMAL
  },
  {
    label: t('form.vipLevel.highPriority'),
    value: VIP_LEVEL.HIGH_PRIORITY
  },
  {
    label: t('form.vipLevel.topTier'),
    value: VIP_LEVEL.TOP_TIER
  }
];

export enum RENTAL_TYPE {
  ALL = 'all',
  SHORT_STAY = 'short_stay',
  LONG_STAY = 'long_stay'
}

export const getRentalTypeOptions = (t: (key: string) => string) => [
  {
    label: t('common.statuses.all'),
    value: RENTAL_TYPE.ALL
  },
  {
    label: t('form.rentalType.shortStay'),
    value: RENTAL_TYPE.SHORT_STAY
  },
  {
    label: t('form.rentalType.longStay'),
    value: RENTAL_TYPE.LONG_STAY
  }
];

export const usePaymentStatusAccOptions = (t: (key: string) => string) => {
  return [
    { label: t('common.statuses.all'), value: '' },
    { label: t('managePage.transactionPage.acc.status.stayed'), value: PAYMENT_STATUS_ACC.STAYED },
    {
      label: t('managePage.transactionPage.acc.status.inHouse'),
      value: PAYMENT_STATUS_ACC.IN_HOUSE
    },
    {
      label: t('managePage.transactionPage.acc.status.deposit'),
      value: PAYMENT_STATUS_ACC.DEPOSIT
    },
    {
      label: t('managePage.transactionPage.acc.status.invoiced'),
      value: PAYMENT_STATUS_ACC.INVOICED
    }
  ];
};

export const useDiscountOption = (t: (key: string) => string) => {
  return [
    { label: t('common.confirm.inputPercentDiscount'), value: 'discount_percent' },
    { label: t('common.confirm.inputAmountDiscount'), value: 'discount_amount' },
    { label: t('common.confirm.inputCodeDiscount'), value: 'discount_code' },
    { label: t('common.confirm.scanQRDiscount'), value: 'discount_qr', disabled: true }
  ];
};
